import React, { Component } from 'react'
import { Row, Col, Modal, Input, Select, DatePicker, Spin, message } from 'antd'
import $ from 'jquery';
import moment from 'moment';

const { TextArea } = Input;
const Option = Select.Option;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY/MM/DD";

export default class NewCompLeave extends Component {

    constructor( props ){
        super( props );

        this.state = {
            user_id: 0,
            start_date: new Date(),
            end_date: new Date(),
            visible: false,
            user_list: []
        }

        this.handleCancel = this.handleCancel.bind( this );
        this.handleOk = this.handleOk.bind( this );
    }

    componentWillReceiveProps( nextProps ){

        this.setState({ 
            visible: nextProps.onVisible,
        });

        if( nextProps.onUsers.length !== 0 ){
            this.setState({
                user_list: nextProps.onUsers
            });
        }

    }

    handleCancel(){
        this.setState({visible: false});
    }

    handleOk(){
        
        let data = {
            user_id: this.state.user_id,
            start_date: this.state.start_date,
            end_date: this.state.end_date
        }

        this.props.onSubmit( data );

    }

    render() {

        const users = this.state.user_list.map( (item, key ) => <Option key={ item.user_id }>{ item.full_name}</Option> )

        return (
            <Modal
                title="Add New Leave"
                maskClosable={ false }
                visible={ this.state.visible }
                onOk={ this.handleOk }
                onCancel={ this.handleCancel }>
                <div>

                    <Row gutter={16} className="mrg_b_10">
                        <Col span={24}>
                            <label>Employee</label>
                            <br />
                            <Select 
                                showSearch
                                placeholder={'Select Employee'}
                                value={ this.state.state }
                                style={{width: '100%'}}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={ (value) => this.setState({ user_id: value }) }>
                                    <Option key={ 0 } disabled>None</Option>
                                    { users }
                            </Select>
                        </Col>
                    </Row>

                    <Row gutter={16} className="mrg_b_10">
                        <Col span={24}>
                            <label>From - To Date</label>
                            <br />
                            <RangePicker 
                                value={[moment( this.state.start_date , dateFormat), moment( this.state.end_date, dateFormat)]}
                                onChange={ 
                                    ( date, dateString ) =>  this.setState({ start_date: dateString[0], end_date: dateString[1] }) 
                                } style={{ width: '100%' }} />
                        </Col>
                    </Row>

                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/compassionate_leaves/childs/new.leave.js